/** @jsxImportSource @emotion/react */
export const SalesPolicyFa = () => {
  return (
    <>
      <div className="headArea">
        <p className="aR">C202173</p>
        <p>お客様各位</p>
        <p className="aR">株式会社フィナンシャル・エージェンシー</p>
      </div>
      <h2>保険商品のご案内にあたって</h2>
      <ol>
        <li>
          当社の販売方針<br />
          保デジWEBよりお客様ご自身でインターネット申込を希望される場合は、当社取扱保険会社のうち保デジWEBに表示可能かつインターネット申込ができる保険会社をご案内いたします。
        </li>
        <li>
          商品のご案内・比較の方法<br />
          お客様への商品のご案内は、以下の手順で進めてまいります。
          <ol className="likeSub">
            <li>①意向の把握：加入目的、ご希望の保障内容などを詳しくお伺いし、お客様のご意向とニーズを正確に把握します。</li>
            <li>②商品の選定：①の内容をもとに、当社が取り扱う複数の保険会社のうちお客様に案内できる商品の中から、お客様のご意向・ニーズに合致する商品を絞り込みます。</li>
            <li>③選定商品提示と説明：選定された複数の商品について、商品の特徴、保険料、保障内容の差異など、お客様が比較検討するために必要な情報をご提供し、わかりやすくご説明いたします。</li>
            <li>④最終的なご判断：ご提示した商品の中から、お客様ご自身に最適な保険商品をご自身の判断でご選択いただきます。</li>
          </ol>
          また、募集プロセスにおいて、お客様へのご説明内容（当社の方針、意向の把握、商品の提示・比較方法など）は、適切な募集が行われているかの確認に使用するため、記録・証跡として社内に保存いたします。
        </li>
        <li>
          提案保険会社以外の保険会社、保険商品をご希望の場合<br />
          お客様がご希望される場合は、上記により選定した商品以外であっても、当社の取扱保険会社の商品であれば、ご案内をさせていただきます。
        </li>
        <li>
          当社の取扱保険会社<br />
          当社は多くのお客様のご要望にお応えできるように生命保険・損害保険において複数の保険会社と代理店委託契約を締結しております。取扱保険会社はこちらをご参照ください。<br />
          <a href="https://www.financial-agency.com/" target="_blank" rel="noreferrer noopener">https://www.financial-agency.com/</a><br />
          当社からご案内する保険のうち一部の保険会社を除き第二分野(損害保険等)は保険契約締結の代理権を有しておりますが、第一分野・第三分野の保険商品(死亡保険・医療保険・ガン保険等)及び一部の第二分野(損害保険等)と少額短期保険は保険会社からの委託を受けてお客様と引受保険会社の保険契約締結の媒介を行います。告知受領権や保険契約の締結の代理権はありません。
        </li>
      </ol>
      <p>保デジ WEB</p>
    </>
  );
};
export default SalesPolicyFa;
